import styled, { css } from 'styled-components';

export const Overlay = styled.div`
  ${({ $expanded, $isFullscreen, theme: { spacing } }) => css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: ${$expanded ? '1fr' : '1fr 377px'};
    background-color: #fafaff;
    gap: ${spacing.lg};
    user-select: text;
    ${$isFullscreen &&
    css`
      gap: 0;
      grid-template-columns: ${$expanded ? '1fr' : '1fr 1fr'};
    `}
  `}
`;

export const TopPanel = styled.div`
  display: flex;
  gap: ${({ theme: { spacing } }) => spacing.md};
`;

export const SidebarWrapper = styled.div`
  ${({ $visible, theme: { spacing } }) => css`
    gap: ${spacing.lg};
    display: flex;
    flex-direction: column;
    min-height: 0;
    ${$visible &&
    css`
      display: none;
    `}
  `}
`;

export const CallPanelWrapper = styled.div`
  ${({ theme: { spacing } }) => css`
    margin-top: auto;
    margin-bottom: ${spacing.md};
  `}
`;

export const CompleteSessionWrapper = styled.div`
  z-index: 4;
  padding-top: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FullScreenButtonWrapper = styled.div`
  padding: 0.45rem 0;
  position: relative;
`;
export const PlayerOverlay = styled.div`
  ${({
    $isPublicPlayer,
    $isFullscreen,
    theme: { spacing, borderRadius, color },
  }) => css`
    background-color: ${color.midnight5};
    ${!$isPublicPlayer &&
    !$isFullscreen &&
    css`
      border-radius: ${borderRadius.sm};
    `}
    padding: ${spacing.md};
    grid-template-rows: 100px 1fr 100px;
    display: grid;
  `}
`;

export const AvatarWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Avatar = styled.img`
  ${({ theme: { borderRadius } }) => css`
    border-radius: ${borderRadius.md};
    max-width: 100%;
    max-height: 100%;
    background: #fff;
  `}
`;

export const EndSessionButtons = styled.div`
  ${({ theme: { spacing } }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing.sm};
    margin-top: ${spacing.sm};
  `}
`;